import { render, staticRenderFns } from "./invlabelfrm.vue?vue&type=template&id=7c78153c"
import script from "./invlabelfrm.vue?vue&type=script&lang=js"
export * from "./invlabelfrm.vue?vue&type=script&lang=js"
import style0 from "./invlabelfrm.vue?vue&type=style&index=0&id=7c78153c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports